
import 'isomorphic-fetch';
import { config } from 'config'

export const api = {
	empresa:{
		async getAll() {
			const response = await fetch(config.URL_API + '/empresas/lista', {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	ventas: {
		async create(data) {
            const response = await fetch(config.URL_API + '/cobros_clientes/alta', {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
		    body: JSON.stringify(data)
        });
            const responseData = await response.json();
            return responseData;
        },
		async imprimir(id, data) {
			const res = await fetch(config.URL_API + '/ventas/' + id + '/imprimir?' + data, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/pdf',
									}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async getAllCC(id,idempresa) {
			const response = await fetch(config.URL_API + `/cuentas_clientes/deuda/${idempresa}/${id}`, {
			// const response = await fetch(config.URL_API + `/cuentas_clientes/deuda/${id}`, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	condicionventa: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/condicionventa?' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			});
			const data = await response.json();
			return data;
		},
	},
	puntosdeventas: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/puntosdeventas?' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			});
			const data = await response.json();
			return data;
		},
	},
	fpago: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/formas_pago&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	clientes: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/clientes&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	pdf:{
		async imprimir(id, mimeType) {
			const res = await fetch(config.URL_API + '/cobros_clientes/pdfRecibo/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id+'.pdf', {type:mimeType})
			return file;
		},
	},
	cobros_clientes: {
		async imprimir(id, data) {
			const res = await fetch(config.URL_API + '/cobros_clientes/pdfRecibo/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
									}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async getAll(query='') {
			const response = await fetch(config.URL_API + '/cobros_clientes/cobros&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
};
